module.exports = __webpack_public_path__ + "img/desk4.83e8c5f9.png";